import React, {  useState, useEffect } from 'react';
import {Alert, Button, Card, Form, Modal, Table} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner, faWrench, faUserShield } from '@fortawesome/free-solid-svg-icons'
import {useAuth} from "../authprovider";
import {
    Link
} from "react-router-dom";

function AddBuildingModal(props){
    const {buildings} = useAuth();
    const [validated, setValidated] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [alert, setAlert] = useState({
        show:false,
        content: "",
    })

    let handleSubmit = (event)=>{

        event.preventDefault();
        event.stopPropagation();

        if(disabled)
            return;

        const form = event.currentTarget;
        if (form.checkValidity() === true) {
            setDisabled(true);
            let elements = form.elements
            let data = {
                name:elements.name.value,
                code:elements.code.value,
                address:elements.address.value,
                users:elements.users.value,
            }


            buildings.add(data, response=>{
                const {success, error, content} = response;
                if(success === true){
                    props.onHide(content);
                } else {
                    setAlert({show:true, content: error})
                }
                setDisabled(false);
            })
        }

        setValidated(true);
    }

    let hideAlert = ()=>{ setAlert({show:false, content: ""})}

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Nowy obiekt
                </Modal.Title>
            </Modal.Header>
            <Form disabled noValidate validated={validated} action={"post"} onSubmit={handleSubmit} >
                <Modal.Body>
                    <Alert show={alert.show} variant={"warning"} onClose={hideAlert} dismissible>
                        <p>
                            {alert.content}
                        </p>
                    </Alert>
                    <Form.Group className="mb-3" controlId="objectName">
                        <Form.Label>Nazwa budynku</Form.Label>
                        <Form.Control required type="text" name={"name"} placeholder="Nazwa budynku" />
                        <Form.Text className="text-muted" >
                            Nazwa budynku - formalna nazwa, niewidoczna dla użytkowników aplikacji mobilnych
                        </Form.Text>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="objectCode">
                        <Form.Label>Kod obiektu</Form.Label>
                        <Form.Control required type="text" name={"code"} placeholder="kod" />
                        <Form.Text className="text-muted" >
                            Krótki,unikalny i jednoznaczny kod obiektu widoczny w aplikacji mobilnej
                        </Form.Text>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="objectAddress">
                        <Form.Label>Adres obiektu</Form.Label>
                        <Form.Control type="text" name={"address"} placeholder="adres" />
                        <Form.Text className="text-muted" >
                            Adres obiektu
                        </Form.Text>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="objectStartUsersLp">
                        <Form.Label>Liczba użytkowników obiektu</Form.Label>
                        <Form.Control type="number" name={"users"} placeholder="0" />
                        <Form.Text className="text-muted" >
                            Opcjonalnie - możesz podać początkową liczbę użytkowników, których utworzyc wraz z dodaniem obiektu do bazy danych
                        </Form.Text>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button disabled={disabled} type={"submit"} name={"Zapisz"}>
                        {disabled ? <FontAwesomeIcon icon={faSpinner}  spin/> : "Zapisz" }
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default function BuildingsManager() {
    const auth = useAuth();
    const [loadBuildings, setLoadBuildings] = useState(true)
    const [buildings, setBuildings] = useState([])
    const [showModalAddEdit, setShowModalAddEdit] = useState(false)


    useEffect(()=>{
        if(loadBuildings){
            auth.buildings.get((response)=>{
                const {success,error,content} = response;
                if(success === true){
                    setLoadBuildings(false)
                    setBuildings(content)
                } else {
                    alert(error);
                }
            });
        }
    })

    const addBuilding = (building)=>{
        setBuildings([...buildings, building])
    }

    const handleHideCreateModal = (result)=>{
        if(result)
            addBuilding(result)
        setShowModalAddEdit(false)
    }


    const handleAddClick = ()=>{
        setShowModalAddEdit(true)
    }

    let lp = 1;

    return (

        <div className={"container"}>
            <Card className={"m-2 p-2"} key={"data"}>
                <div >
                    <Button name={"Dodaj"} className="me-4" style={{position:"fixed", bottom:"10px", right:"10px"}} variant="warning " onClick={handleAddClick} >Dodaj</Button>
                    <Table striped bordered hover>
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>Nazwa</th>
                            <th>Kod</th>
                            <th>Adres</th>
                            <th>Użytkownicy</th>
                            <th>Edycja</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            buildings && buildings.map(building=>{
                                return (
                                        <tr key={building.id}>
                                            <td>{lp++}</td>
                                            <td>{building.name}</td>
                                            <td>{building.code}</td>
                                            <td>{building.address}</td>
                                            <td>{building.users}</td>
                                            <td>
                                                <Link className={"btn btn-outline-info me-2"} to={{
                                                    pathname: "/controll",
                                                    hash: building.id,
                                                    state: { fromDashboard: true }
                                                }}><FontAwesomeIcon icon={faUserShield} /></Link>
                                                <Link className={"btn btn-danger"} to={"/building#"+building.id}><FontAwesomeIcon icon={faWrench} /></Link>
                                            </td>
                                        </tr>
                                )
                            })
                        }
                        </tbody>
                    </Table>
                </div>
                <AddBuildingModal show={showModalAddEdit } onHide={handleHideCreateModal}/>
            </Card>
        </div>
    )

}
